<template>
  <section style="max-width: 1366px; margin: 0 auto;">
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <b-field>
            <b-input
              v-model="search"
              placeholder="請輸入銀行名稱或代碼"
              type="search"
              icon="magnify"
              @input="onFilter"
            ></b-input>
          </b-field>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-button
              :loading="loading"
              class="is-primary"
              icon-left="plus"
              @click="onAdd"
            >
              {{ $t('attributes.add') }}
            </b-button>
          </b-field>
        </div>
      </div>
    </nav>
    <b-table
      ref="table"
      :data="items"
      :loading="loading"
      :mobile-cards="true"
      hoverable
      narrowed
      scrollable
      detailed
      detail-key="number"
      :show-detail-icon="false"
      paginated
      pagination-position="both"
      backend-pagination
      backend-sorting
      :total="total"
      :per-page="perPage"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @page-change="onPageChange"
      @sort="onSort"
    >
      <b-table-column
        field="number"
        :label="$t('attributes.airline_code')"
        width="100"
        sortable
        centered
        cell-class="nowrap"
        v-slot="props"
      >
        {{ props.row.bank_number }}
      </b-table-column>
      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        sortable
        centered
        cell-class="nowrap"
        v-slot="props"
      >
        {{ props.row.bank_name }}
      </b-table-column>
      <b-table-column
        :label="$t('attributes.function')"
        width="220"
        centered
        v-slot="props"
      >
        <b-button type="is-primary" @click.prevent="onModify(props.row)">
          {{ $t('attributes.modify') }}
        </b-button>
      </b-table-column>
    </b-table>
    <b-modal
      :active.sync="isFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <bank-detail :mode="formMode" :data="selectedItem" @send="onSend" />
    </b-modal>
    <b-loading
      :active.sync="loading"
      :is-full-page="true"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>
<script>
import { BUSINESS_ENTITY_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import debounce from 'lodash/debounce'
import BankDetail from '@/components/basic/BankDetail.vue'

export default {
  name: 'BankList',
  components: { BankDetail },
  props: {
    query: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      isFormModalActive: false,
      formMode: '',

      total: 0,
      sort_by: this.query.sort || 'bank_number',
      by_descending: this.query.order === 'desc',
      defaultSortOrder: 'asc',
      page: parseInt(this.query.page) || 1,
      perPage: this.query.page_size || 30,
      sortField: this.query.sort_by || 'bank_number',
      sortOrder: this.query.order || 'asc',

      search: '',
      items: [],
      selectedItem: null
    }
  },
  watch: {
    query(newQuery) {
      this.getQuery(newQuery)
      this.loadItems()
    }
  },
  mounted() {
    this.loadItems()
  },
  methods: {
    async loadItems() {
      try {
        const api = `${BUSINESS_ENTITY_API}/banks`
        const params = {
          search: this.search,
          sort_by: this.sort_by,
          by_descending: this.by_descending,
          page_size: this.perPage,
          page_number: this.page
        }
        this.loading = true
        const res = await this.axios.get(api, { params })
        const data = res.data.data
        this.items = data.items
        this.total = data.item_count
      } catch (e) {
        this.selectedItem = null
        this.items = []
        this.total = 0

        notifyService.fetch_error('bank', e)
      } finally {
        this.loading = false
      }
    },
    onFilter: debounce(function() {
      this.page = 1
      this.updateQuery()
    }, 500),
    onPageChange(page) {
      this.page = page
      this.updateQuery()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.updateQuery()
    },
    onAdd() {
      this.selectedItem = {
        id: '',
        bank_name: '',
        bank_number: '',
        bank_short_name: ''
      }
      this.formMode = 'create'
      this.isFormModalActive = true
    },
    onModify(item) {
      this.selectedItem = item
      this.formMode = 'update'
      this.isFormModalActive = true
    },
    onSend(item) {
      if (this.formMode === 'create') {
        this.onCreated(item)
      } else {
        this.onUpdated(item)
      }
    },
    async onCreated(item) {
      try {
        const api = `${BUSINESS_ENTITY_API}/banks/create`
        this.loading = true
        await this.axios.post(api, item)
        this.isFormModalActive = false
        notifyService.success(this.$t('attributes.add_succeed'))

        await this.loadItems()
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.loading = false
      }
    },
    async onUpdated(item) {
      try {
        const api = `${BUSINESS_ENTITY_API}/banks/${item.id}`
        this.loading = true
        await this.axios.put(api, item)
        this.isFormModalActive = false
        notifyService.success(this.$t('attributes.update_succeed'))

        await this.loadItems()
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
